function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.97 0C15.539 0 16 .461 16 1.03v13.94A1.03 1.03 0 0114.97 16H1.03A1.03 1.03 0 010 14.97V1.03C0 .461.461 0 1.03 0zm-2.571 4.296a.667.667 0 00-.932.141l-4.259 5.776L4.417 7.98a.669.669 0 00-1.084.417.667.667 0 00.25.624l3.334 2.666a.675.675 0 00.953-.124l4.667-6.334a.664.664 0 00-.138-.933z"
});

function SvgHappyCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgHappyCheck;